const e = (n, r) => {
  let t = Math.random().toString(36).substring(2, 9);
  return n && (t = `${n}-${t}`), r && (t = `${t}-${r}`), t;
};
export {
  e as g
};
//# sourceMappingURL=generate-random-id.f7e64105.js.map
